/* @flow */
// typecheck: ignore file
import React from 'react';
import PeopleTable from 'components/PeopleTable.jsx';
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import Group from 'entities/Group';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import './styles/AdminPeopleTable.scss';

type Props = {
  params: {
    schoolId: number,
  },
  organization?: {
    paid: boolean,
    class: ?Object,
  }
};

function AdminPeopleTable(props: Props) {
  const { organization } = props;

  if (!organization) {
    return null;
  }

  const { paid } = organization;
  const groupEntity = organization && organization.class && Group.fromJSON(organization.class);

  return (
    <div className="AdminPeopleTable">
      <PeopleTable disabled={!paid} group={groupEntity} namespace={String(props.params.schoolId)} />
    </div>
  );
}

const withOrganizationAndClass = graphql(gql`
  ${classesDefaultsFragment}

  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
      class {
        ...classesDefaults
      }
    }
  }
  `,
  {
    options: ({ params }) => ({
      variables: { organizationId: [params.schoolId] },
    }),
    props: ({ data }) => ({
      organization: data.organizations ? data.organizations[0] : null,
    }),
  }
);

export default withOrganizationAndClass(AdminPeopleTable);



// WEBPACK FOOTER //
// ./src/admin/components/AdminPeopleTable.jsx